import { Controller } from "@hotwired/stimulus"
import { i18n } from "../lib/i18n"

export default class extends Controller {
  static targets = ["formContent", "neighborSignatureData", "staffSignatureData"]
  static values = {
    neighborId: Number,
    hasSigned: Boolean,
    signedDocumentUrl: String,
    returnTo: String
  }

  declare readonly formContentTarget: HTMLElement
  declare readonly neighborSignatureDataTarget: HTMLInputElement
  declare readonly staffSignatureDataTarget: HTMLInputElement
  declare readonly neighborIdValue: number
  declare readonly hasSignedValue: boolean
  declare readonly signedDocumentUrlValue: string
  declare readonly returnToValue: string
  declare readonly hasReturnToValue: boolean

  validateBeforeSubmit(event: Event) {
    if (!this.neighborSignatureDataTarget.value) {
      event.preventDefault()
      alert(i18n.t('consent_form.neighbor_signature_required'))
      return false
    }

    if (!this.staffSignatureDataTarget.value) {
      event.preventDefault()
      alert(i18n.t('consent_form.staff_signature_required'))
      return false
    }

    return true
  }

  viewSignedDocument() {
    if (this.signedDocumentUrlValue) {
      window.open(this.signedDocumentUrlValue, '_blank')
    }
  }

  returnToOrigin() {
    if (this.hasReturnToValue && this.returnToValue) {
      const frame = document.getElementById('dynamic_modal_frame') as HTMLElement & { src: string }
      if (frame) frame.src = this.returnToValue
    } else {
      this.closeModal()
    }
  }

  private closeModal() {
    const modal = document.getElementById('dynamic_modal')
    if (modal) {
      modal.classList.remove('modal-open')
    }
  }
}
